import { Box, Stack } from '@mui/material';
import { CleaningMission, OPEN_CLEANING_MISSION_STATUSES } from '@silbo/core';
import { colors } from '@silbo/ui';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { useConfigContext } from '../../../contexts/ConfigContext/useConfigContext';
import MissionStatusBanner from './MissionStatusBanner';
import MissionComments from './MissionComments';
import MissionInfoRows from './MissionInfoRows';

type CleaningMissionDetailsProps = {
  mission: CleaningMission;
  now: Date;
};

/** Tout en lecture, sauf le commentaire que l'agent ajoute. Rien qui identifie un patient. */
const CleaningMissionDetails = ({ mission, now }: CleaningMissionDetailsProps) => {
  const { user } = useAuthenticationContext();
  const { config } = useConfigContext();
  const isMissionOpen = OPEN_CLEANING_MISSION_STATUSES.includes(mission.status);
  const canComment = isMissionOpen && (!!config?.cleanBeds || !!config?.manageEnvironmentalCleaning);

  return (
    <Stack spacing={4}>
      <MissionStatusBanner mission={mission} userId={user?.id} now={now} />
      <MissionInfoRows mission={mission} userId={user?.id} now={now} />
      {/* Stack remet à zéro les marges de ses enfants : sans !important, la bande ne touche pas les bords. */}
      <Box sx={{ height: 8, marginX: '-16px !important', bgcolor: colors.blue[5] }} />
      <MissionComments mission={mission} userId={user?.id} canComment={canComment} now={now} />
    </Stack>
  );
};

export default CleaningMissionDetails;
